var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSelectedStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 52,
    viewBox: "0 0 20 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52495 25.7995C3.65795 25.7995 3.05995 26.5145 2.94795 27.3725L1.50995 38.4275C1.39995 39.2855 2.21995 40.0005 3.08695 40.0005H16.9119C17.7799 40.0005 18.6019 39.2855 18.4899 38.4275L17.0519 27.3725C16.9409 26.5145 16.3419 25.7995 15.4749 25.7995H14.6989V25.0025C14.6989 18.3325 5.30095 18.3325 5.30095 25.0025V25.8005H4.52495V25.7995ZM13.0829 25.7995H6.91695V25.0025C6.91695 20.4625 13.0829 20.4625 13.0829 25.0025V25.8005V25.7995ZM6.07995 28.5175C6.79795 28.5175 7.37995 29.0985 7.37995 29.8155C7.37995 30.5315 6.79795 31.1125 6.07995 31.1125C5.36095 31.1125 4.77895 30.5325 4.77895 29.8155C4.77895 29.0985 5.36095 28.5175 6.07895 28.5175H6.07995ZM13.9189 28.5175C14.6369 28.5175 15.2189 29.0985 15.2189 29.8155C15.2189 30.5315 14.6369 31.1125 13.9189 31.1125C13.1999 31.1125 12.6179 30.5325 12.6179 29.8155C12.6179 29.0985 13.1999 28.5175 13.9179 28.5175H13.9189Z",
    fill: "#585B63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 49,
    r: 3,
    fill: "#9698F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectedStore);
export default __webpack_public_path__ + "static/media/ic_selected_store.c16a5f8d5033ff4da2d230590726cbe7.svg";
export { ForwardRef as ReactComponent };